import React, { useEffect, useState } from 'react';
import { Check, X, Trash2 } from 'react-feather';

import RoundedInput from './RoundedInput';

const Response = props => {
  const {
    response,
    deleteResponse,
    interactionId,
    scenarioId,
    index,
    setResponses,
    updateResponse,
    showStrongErrors,
  } = props;
  const { correct, id: responseId, subject } = response;
  // Once all users are converted to portable architecture for Conversations in ODP, we will want
  // to update all references to text, including this hook, to use 'subject' instead.
  const [text, setText] = useState(response.text || subject);
  const [explanation, setExplanation] = useState(response.explanation);
  const [shouldUpdate, setShouldUpdate] = useState(false);

  useEffect(() => {
    if (shouldUpdate) {
      updateResponse(responseId, {
        subject: text,
        explanation,
        correct,
        id: responseId,
      });
      setResponses({
        subject: text,
        explanation,
        correct,
        id: responseId,
        position: response.position,
      });
      setShouldUpdate(false);
    }
  }, [
    scenarioId,
    interactionId,
    responseId,
    text,
    explanation,
    shouldUpdate,
    setResponses,
    correct,
    updateResponse,
    response.position,
  ]);

  return (
    <>
      <span className="d-f fd-c ai-fe w-85p as-fe m-w-fill">
        <span className="w-fill d-f">
          <RoundedInput
            labelText={
              <span className="d-f ai-c">
                {correct ? (
                  <Check className="c-success mr-4" />
                ) : (
                  <X className="c-danger-red mr-4" />
                )}
                <>
                  {correct
                    ? `${t(
                        'practice.on_demand_practice.editor.conversations.correct_response',
                      )}`
                    : `${t(
                        'practice.on_demand_practice.editor.conversations.incorrect_response',
                      )}`}
                  <span className="ml-4 c-danger-red">*</span>
                </>
              </span>
            }
            placeholderText={
              correct
                ? t(
                    'practice.on_demand_practice.editor.conversations.correct_response_placeholder',
                  )
                : t(
                    'practice.on_demand_practice.editor.conversations.incorrect_response_placeholder',
                  )
            }
            value={text}
            wide
            className="ai-fe"
            onChange={updatedResponse => {
              setText(updatedResponse);
              setShouldUpdate(true);
            }}
            singleLine
            id={`conversation-interaction-response-${responseId}`}
            hasError={!text}
            showStrongErrors={showStrongErrors}
          />
          {index > 1 && (
            <button
              type="button"
              onClick={() => deleteResponse(responseId)}
              className="border-0 ml-8 d-f fd-c mb-16 mt-72 bg-white"
              data-test-id={`deleteResponse-${responseId}`}
            >
              <Trash2 className="fz-20 c-gray-darker h-c-gray-darkest" />
            </button>
          )}
        </span>
        <RoundedInput
          labelText={
            <>
              {t(
                'practice.on_demand_practice.editor.conversations.explanation',
              )}
              <span className="ml-4">
                {t('practice.on_demand_practice.editor.conversations.optional')}
              </span>
            </>
          }
          id={`conversation-interaction-explanation-${responseId}`}
          placeholderText={
            correct
              ? t(
                  'practice.on_demand_practice.editor.conversations.explanation_correct_placeholder',
                )
              : t(
                  'practice.on_demand_practice.editor.conversations.explanation_incorrect_placeholder',
                )
          }
          value={explanation}
          className="ai-fe fs-i"
          textClassName="llui-text-body"
          onChange={updatedResponse => {
            setExplanation(updatedResponse);
            setShouldUpdate(true);
          }}
          singleLine
          showStrongErrors={showStrongErrors}
        />
      </span>
      <hr className="w-fill mb-4" />
    </>
  );
};

export default Response;
